import request from '@/utils/request';

export const CAMPAIGN_PAGE_SUBSCRIPTIONS = 'CAMPAIGN_PAGE_SUBSCRIPTIONS';

export const fetchCampaignPageSubscriptions =
  (userId = null) =>
  async dispatch => {
    const response = await request({
      path: `/v1/campaign_page_subscriptions`,
      query: userId ? { user_id: userId } : {}
    });
    dispatch({
      payload: response,
      type: CAMPAIGN_PAGE_SUBSCRIPTIONS
    });
  };

export const createCampaignPageSubscription =
  (body = {}) =>
  async () =>
    await request({
      path: `/v1/campaign_page_subscriptions/create_subscription`,
      method: 'POST',
      body
    });

export const updateCampaignPageSubscription =
  (subscriptionId, body = {}) =>
  async () =>
    await request({
      path: `/v1/campaign_page_subscriptions/update_subscription`,
      method: 'PATCH',
      body: { ...body, id: subscriptionId }
    });

export const cancelCampaignPageSubscription = subscriptionId => async () =>
  await request({
    path: `/v1/campaign_page_subscriptions/cancel`,
    method: 'PATCH',
    body: { id: subscriptionId }
  });
